import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"
import * as getters from "./getters"
import * as actions from "./actions"
import * as mutations from "./mutations"

Vue.use(Vuex)

const state = {
  lafia_user: {
    is_logined: false,
    user_id: "",
    name: "",
    phone: "",
    email: "",
    profile_image: "",
    sns_profile_image: "", // SNS 프로필 이미지 URL (Google, Kakao 등)
    type: "",
    status: "",
    created: "",
    id: undefined, // JWT 사용자 ID
    userType: undefined, // JWT 사용자 타입 (user, admin, staff)
  },

  lang: "",

  temp_sns_user: {},
  promotionCode: null,

  default_price: null,
  default_package_price: null,

  operation_time: null,
  concepts: [],
  isSupportAbroadPay: true,

  app_reload_time: 0,

  // JWT 인증 상태
  accessToken: null,
  isRefreshing: false,
  refreshPromise: null,
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [
    createPersistedState({
      // 테스트 화면은 본사이트 로그인 정보와 따로 저장한다.
      key: process.env.VUE_APP_PREMIUM_TEST === "true" ? "lafia-premium-category-test" : "vuex",
      paths: ["lafia_user", "app_reload_time", "lang", "accessToken"],
    }),
  ],
})
